
import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { FinancialYear } from "../CommonDDL/FinancialYear/FinancialYear";
import { MonthDDL } from "../CommonDDL/Month/MonthDDL";
import { useAuthState } from "../../helper/Context/context";
import { logout } from "../../helper/Context/action";
export const AdminHeader = (props) => {

	const { toggle, isopen, } = props
	const dispatch = useDispatch();
	const userDetails = useAuthState();
	const { UserID, token, year, setYear, Month, setMonth } = userDetails.user
	const { Language, setLanguage } = userDetails

	const [FinancialYearID, setFinancialYearID] = useState({
		DDL: [],
		ID: 0,
		Label: "Year...",
	})

	const [MonthID, setMonthID] = useState({
		DDL: [],
		ID: 0,
		Label: "Month...",
	})

	const [sticky, setSticky] = useState(false)
	const navigation = useNavigate()

	function toggleuser() {
		let side = document.getElementById("userdata")
		side.classList.toggle("hidden1")
		side.classList.toggle("visible")

	}

	const Logout = () => {
		logout(dispatch);
		navigation('/')
		sessionStorage.clear()
	}

	const Navigate = useNavigate()

	return (
		<div className="wrapper admin-header-wrapper mx-0 mb-5 row w-100 px-0" >

			<nav className="mt-3 ms-lg-3 mx-lg-5 navbar fixed-tops admin-header header dark-shadow border-gray py-lg-0"
				style={{ width: isopen ? "calc(100% - 35px)" : "calc(100% - 35px)", marginLeft: isopen ? "" : "4px", marginTop: sticky ? "14px" : "", }}
			>

				<div className="mx-0 navbar-menu-wrapper admin-header-inner d-flex align-items-center justify-content-start" >

					<button
						onClick={toggle}
						className=" navbar-toggler align-self-center hamber pe-lg-3 pe-xl-0"
						type="button"
						data-toggle="minimize"
					>
						<span className="icon-menu"></span>
					</button>

					<div className="nav_swaraj_slogon admin-header-brand ps-3">
						<div className="admin-header-brand-inner">
							<div className="admin-header-logo">
								<img
									src="/Static/Assets/Img/logo.png"
									className="logo cursor-pointer" width={70}
									alt="logo"
									onClick={() => Navigate('/MainDashboard')}
								/>
							</div>
							<div className="admin-header-title d-flex align-items-center">

								<h5 className="text-white pt-1 fw-bold">
									Marine Insurance Learning and Sharing Online</h5>

							</div>
						</div>

					</div>

					<div className="admin-header-controls d-flex align-items-center justify-content-end">
						<div className="admin-header-selectors d-flex align-items-center">
							<div className="admin-header-selector">
												<FinancialYear
													FinancialYearID={FinancialYearID}
													setFinancialYearID={setFinancialYearID}
												/>
											</div>

							<div className="admin-header-selector">
												<MonthDDL
													MonthID={MonthID}
													setMonthID={setMonthID}
												/>
											</div>
										</div>

										{/* <div className="col-3 col-lg-3 d-flex align-items-center justify-content-center">
											<div className="d-flex align-items-center justify-content-center">
												<button
													type="button"
													className="border-0 bg-transparent p-0"
													onClick={() => setLanguage({
														...Language,
														ID: Language.ID === 1 ? 2 : 1,
														Label: Language.ID === 1 ? "Marathi" : "English",
													})}
													aria-label={`Switch to ${Language.ID === 1 ? "Marathi" : "English"}`}
													title={`Switch to ${Language.ID === 1 ? "Marathi" : "English"}`}
												>
													<img
														src={`/Static/Assets/Img/${Language.ID === 1 ? "translateEnglish.png" : "translateMarathi.png"}`}
														alt={Language.Label}
														height={28}
													/>  
													<span className="ms-2 text-white fw-bold">{Language.Label == "English" ? "Eng" : Language.Label == "Marathi" ? "Mar" : ""}</span>
												</button>
											</div>
										</div> */}

										<div className="admin-header-profile position-relative" >
											<li className="nav-item nav-profile dropdown">
												<a
													onClick={(e) => {
														e.preventDefault();
														toggleuser();
													}}
													className="nav-link dropdown-toggle"
													href="javascript:void(0)"
													data-toggle="dropdown"
													id="profileDropdown"
												>
													<img src="/Static/Assets/Img/man.png" className="" alt="profile" />

													<i
														className="align-self-center ml-1"
													>
													</i>
												</a>

												<div id="userdata"
													className="dropdown-menu dropdown-menu-right navbar-dropdown"
													aria-labelledby="profileDropdown"
													style={{ right: 0, left: "auto", top: "100%", minWidth: "120px" }}
												>
													<Link onClick={() => Logout()} className="dropdown-item">

														<div className="drop_item_two my-1">
															Logout
														</div>
													</Link>
												</div>

											</li>

										</div>

						</div>
					</div>

			</nav>

		</div>
	);
}
